import PropTypes from 'prop-types';

import { ROLES } from './constants';

/**
 * Full shape of account-user model
 */
const Shape = {
  createdAt: PropTypes.number,
  enabledAt: PropTypes.number,
  invitedAt: PropTypes.number,
  roleId: PropTypes.oneOf(Object.values(ROLES)),
  status: PropTypes.oneOf(['enabled', 'invited']),
};

export default PropTypes.shape(Shape);
